import React from 'react';
import './Home.css';
const Calidad = ({submenu}) => {
    return (
        <div className="home">
            <div>
                <h2 className = "home-pag-name">Calidad</h2>
                <p>Esta es la página principal de Calidad</p>
                <p>{submenu}</p>
            </div>
        </div>
    );
}

export default Calidad;